
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2019-05-31-secure-cloud-storage",
      function () {
        return require("private-next-pages/posts/2019-05-31-secure-cloud-storage.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2019-05-31-secure-cloud-storage"])
      });
    }
  